import React from 'react'

interface Props {
  onClick: () => void
  title?: string
}

export const CancelButton: React.FC<Props> = ({title = 'Cancel', ...props}) => {
  return (
    <div className='me-5'>
      <button id='btnOrderCancel' type='button' className='btn explore-btn-outline' {...props}>
        {title}
      </button>
    </div>
  )
}

export default CancelButton
